import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class SeatsioService {
    showDesigner(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const seatsioInstance = yield this.getSeatsio(config.region, config.chartJsUrl);
            delete config['chartJsUrl'];
            delete config['region'];
            return new seatsioInstance.SeatingChartDesigner(config).render();
        });
    }
    showSeatingChart(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const seatsioInstance = yield this.getSeatsio(config.region, config.chartJsUrl);
            delete config['chartJsUrl'];
            delete config['region'];
            return new seatsioInstance.SeatingChart(config).render();
        });
    }
    showEventManager(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const seatsioInstance = yield this.getSeatsio(config.region, config.chartJsUrl);
            delete config['chartJsUrl'];
            delete config['region'];
            return new seatsioInstance.EventManager(config).render();
        });
    }
    showChartManager(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const seatsioInstance = yield this.getSeatsio(config.region, config.chartJsUrl);
            delete config['chartJsUrl'];
            delete config['region'];
            return new seatsioInstance.ChartManager(config).render();
        });
    }
    getSeatsio(region, chartJsUrl) {
        if (typeof seatsio !== 'undefined') {
            return Promise.resolve(seatsio);
        }
        return this.loadSeatsio(region, chartJsUrl);
    }
    loadSeatsio(region, chartJsUrl = 'https://cdn-{region}.seatsio.net/chart.js') {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.onload = () => resolve(seatsio);
            script.onerror = () => reject(`Could not load ${script.src}`);
            script.src = chartJsUrl.replace('{region}', region);
            document.head.appendChild(script);
        });
    }
    ngOnDestroy() {
    }
    ngOnInit() {
    }
}
SeatsioService.ɵfac = function SeatsioService_Factory(t) { return new (t || SeatsioService)(); };
/** @nocollapse */ SeatsioService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SeatsioService_Factory() { return new SeatsioService(); }, token: SeatsioService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class SeatsioComponent {
    constructor(seatsioService) {
        this.id = 'chart';
        this.seatsioService = seatsioService;
    }
    render(config) {
        throw new Error('Not implemented');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config['divId']) {
                this.id = this.config['divId'];
            }
            if ('onRenderStarted' in this.config) {
                this.config['onRenderStarted']();
            }
            this.chart = yield this.render(this.config);
        });
    }
    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    }
}
SeatsioComponent.ɵfac = function SeatsioComponent_Factory(t) { return new (t || SeatsioComponent)(ɵngcc0.ɵɵdirectiveInject(SeatsioService)); };
SeatsioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeatsioComponent, selectors: [["ng-component"]], inputs: { id: "id", config: "config", class: "class" }, decls: 0, vars: 0, template: function SeatsioComponent_Template(rf, ctx) { }, encapsulation: 2 });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
SeatsioComponent.ctorParameters = () => [
    { type: SeatsioService }
];
/** @type {!Object<string, !Array<{type: !Function, args: (undefined|!Array<?>)}>>} */
SeatsioComponent.propDecorators = {
    id: [{ type: Input }],
    config: [{ type: Input }],
    class: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioComponent, [{
        type: Component,
        args: [{ template: '' }]
    }], function () { return [{ type: SeatsioService }]; }, { id: [{
            type: Input
        }], config: [{
            type: Input
        }], class: [{
            type: Input
        }] }); })();

class SeatsioDesignerComponent extends SeatsioComponent {
    constructor(seatsioService) {
        super(seatsioService);
    }
    render(config) {
        return this.seatsioService.showDesigner(this.config);
    }
}
SeatsioDesignerComponent.ɵfac = function SeatsioDesignerComponent_Factory(t) { return new (t || SeatsioDesignerComponent)(ɵngcc0.ɵɵdirectiveInject(SeatsioService)); };
SeatsioDesignerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeatsioDesignerComponent, selectors: [["si-seatsio-designer"]], features: [ɵngcc0.ɵɵProvidersFeature([SeatsioService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 4, consts: [[2, "height", "100vh", 3, "id"]], template: function SeatsioDesignerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
    } }, styles: [""] });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
SeatsioDesignerComponent.ctorParameters = () => [
    { type: SeatsioService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioDesignerComponent, [{
        type: Component,
        args: [{
                selector: 'si-seatsio-designer',
                template: "<div id=\"{{id}}\" style=\"height: 100vh\" class=\"{{class}}\">\n</div>\n",
                providers: [SeatsioService],
                styles: [""]
            }]
    }], function () { return [{ type: SeatsioService }]; }, null); })();

class SeatsioSeatingChartComponent extends SeatsioComponent {
    constructor(seatsioService) {
        super(seatsioService);
    }
    render(config) {
        return this.seatsioService.showSeatingChart(this.config);
    }
}
SeatsioSeatingChartComponent.ɵfac = function SeatsioSeatingChartComponent_Factory(t) { return new (t || SeatsioSeatingChartComponent)(ɵngcc0.ɵɵdirectiveInject(SeatsioService)); };
SeatsioSeatingChartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeatsioSeatingChartComponent, selectors: [["si-seatsio-seating-chart"]], features: [ɵngcc0.ɵɵProvidersFeature([SeatsioService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 4, consts: [[2, "height", "100vh", 3, "id"]], template: function SeatsioSeatingChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
    } }, styles: [""] });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
SeatsioSeatingChartComponent.ctorParameters = () => [
    { type: SeatsioService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioSeatingChartComponent, [{
        type: Component,
        args: [{
                selector: 'si-seatsio-seating-chart',
                template: "<div id=\"{{id}}\" style=\"height: 100vh\" class=\"{{class}}\">\n</div>\n",
                providers: [SeatsioService],
                styles: [""]
            }]
    }], function () { return [{ type: SeatsioService }]; }, null); })();

class SeatsioEventManagerComponent extends SeatsioComponent {
    constructor(seatsioService) {
        super(seatsioService);
    }
    render(config) {
        return this.seatsioService.showEventManager(this.config);
    }
}
SeatsioEventManagerComponent.ɵfac = function SeatsioEventManagerComponent_Factory(t) { return new (t || SeatsioEventManagerComponent)(ɵngcc0.ɵɵdirectiveInject(SeatsioService)); };
SeatsioEventManagerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeatsioEventManagerComponent, selectors: [["si-seatsio-event-manager"]], features: [ɵngcc0.ɵɵProvidersFeature([SeatsioService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 4, consts: [[2, "height", "100vh", 3, "id"]], template: function SeatsioEventManagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
    } }, styles: [""] });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
SeatsioEventManagerComponent.ctorParameters = () => [
    { type: SeatsioService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioEventManagerComponent, [{
        type: Component,
        args: [{
                selector: 'si-seatsio-event-manager',
                template: "<div id=\"{{id}}\" style=\"height: 100vh\" class=\"{{class}}\">\n</div>\n",
                providers: [SeatsioService],
                styles: [""]
            }]
    }], function () { return [{ type: SeatsioService }]; }, null); })();

class SeatsioChartManagerComponent extends SeatsioComponent {
    constructor(seatsioService) {
        super(seatsioService);
    }
    render(config) {
        return this.seatsioService.showChartManager(config);
    }
}
SeatsioChartManagerComponent.ɵfac = function SeatsioChartManagerComponent_Factory(t) { return new (t || SeatsioChartManagerComponent)(ɵngcc0.ɵɵdirectiveInject(SeatsioService)); };
SeatsioChartManagerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SeatsioChartManagerComponent, selectors: [["si-seatsio-chart-manager"]], features: [ɵngcc0.ɵɵProvidersFeature([SeatsioService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 4, consts: [[2, "height", "100vh", 3, "id"]], template: function SeatsioChartManagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
    } }, styles: [""] });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
SeatsioChartManagerComponent.ctorParameters = () => [
    { type: SeatsioService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioChartManagerComponent, [{
        type: Component,
        args: [{
                selector: 'si-seatsio-chart-manager',
                template: "<div id=\"{{id}}\" style=\"height: 100vh\" class=\"{{class}}\">\n</div>\n",
                providers: [SeatsioService],
                styles: [""]
            }]
    }], function () { return [{ type: SeatsioService }]; }, null); })();

class SeatsioAngularModule {
}
SeatsioAngularModule.ɵfac = function SeatsioAngularModule_Factory(t) { return new (t || SeatsioAngularModule)(); };
SeatsioAngularModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SeatsioAngularModule });
SeatsioAngularModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeatsioAngularModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SeatsioComponent,
                    SeatsioDesignerComponent,
                    SeatsioSeatingChartComponent,
                    SeatsioEventManagerComponent,
                    SeatsioChartManagerComponent
                ],
                imports: [],
                exports: [
                    SeatsioDesignerComponent,
                    SeatsioSeatingChartComponent,
                    SeatsioEventManagerComponent,
                    SeatsioChartManagerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SeatsioAngularModule, { declarations: [SeatsioComponent, SeatsioDesignerComponent, SeatsioSeatingChartComponent, SeatsioEventManagerComponent, SeatsioChartManagerComponent], exports: [SeatsioDesignerComponent, SeatsioSeatingChartComponent, SeatsioEventManagerComponent, SeatsioChartManagerComponent] }); })();

/*
 * Public API Surface of seatsio-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SeatsioAngularModule, SeatsioChartManagerComponent, SeatsioDesignerComponent, SeatsioEventManagerComponent, SeatsioSeatingChartComponent, SeatsioService, SeatsioComponent as ɵa };

